<div class="backModal enMotivo">
  <div class="close closeModal">
    <a (click)="close()" title="cerrar"
      ><span class="cross"></span><span class="sr-only">cerrar</span></a
    >
  </div>
  <div class="aviso">
    <div class="MotivosModalLayout">
      <div class="MotivosModalLeft">
        <div class="wrap-tabs-entradas">
          <div class="tabs-entradas">
            <ul *ngIf="categorias">
              <li
                *ngFor="let cat of categorias"
                [ngClass]="{
                  active: categoriaActiva.Id === cat.Id,
                  destacada: deberiaDestacarse(cat.Id)
                }"
                (click)="seleccionCategoria(cat.Id)"
              >
                <a>{{ cat.Nombre }}</a>
              </li>
            </ul>
          </div>
          <div id="tabs-content-entradas">
            <div id="tabSel-01">
              <div class="Rtable">
                <div class="Rtable-row Rtable-row--head">
                  <div class="Rtable-cell item-cell column-heading">
                    {{ 'ITEM' | translate }}
                  </div>
                  <div class="Rtable-cell precio-cell column-heading">
                    {{ 'PRECIO' | translate }}
                  </div>
                  <!-- <div class="Rtable-cell cantidad-cell column-heading">{{'CANTIDAD' | translate}}</div> -->
                </div>

                <div class="listado">
                  <div *ngIf="entradas">
                    <div
                      class="Rtable-row"
                      [ngClass]="{
                        active: getCantidadPorEntrada(entrada) > 0,
                        selected: entradaSeleccionada === entrada
                      }"
                      (click)="seleccionarEntrada(entrada)"
                      *ngFor="let entrada of pagedItems"
                    >
                      <div class="Rtable-cell item-cell">
                        <div class="Rtable-cell--content item-content">
                          {{ entrada.NombrePantalla }}
                        </div>
                      </div>
                      <div class="Rtable-cell precio-cell">
                        <div class="Rtable-cell--content precio-content">
                          {{
                            entrada.PrecioEnDivisaReferencia
                              | myCurrency
                                : divisaSimboloDecimal
                                : divisaDecimales
                                : divisaPosicion
                                : divisaSimbolo
                                : divisaSimboloDerecha
                                : divisaSimbSeparacionMiles
                          }}
                        </div>
                      </div>
                      <input
                        style="visibility: hidden; display: none"
                        id="extra-{{ entrada.idTarifa }}"
                        value="{{ getCantidadPorEntrada(entrada) }}"
                        type="number"
                        class="qty text"
                        step="1"
                        min="0"
                        name="quantity"
                        category="CANTIDAD"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <ul
                class="pagination"
                *ngIf="pager.pages && pager.pages.length > 1"
              >
                <li>
                  <a (click)="setPage(pager.currentPage - 1)" title="Previo">
                    <img
                      class="svg"
                      src="assets/img/active-arrow.svg"
                      alt="icono prev"
                    />
                  </a>
                </li>
                <li *ngFor="let page of pager.pages">
                  <a
                    (click)="setPage(page)"
                    [ngClass]="{ active: pager.currentPage === page }"
                    >{{ page }}</a
                  >
                </li>
                <li>
                  <a (click)="setPage(pager.currentPage + 1)" title="Próximo">
                    <img
                      class="svg"
                      src="assets/img/active-arrow.svg"
                      alt="icono next"
                    />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="MotivosModalRight">
        <ticketing-resumen-compra></ticketing-resumen-compra>
      </div> -->
    </div>
  </div>
</div>
